module.exports = __webpack_public_path__ + "img/automation-delete.eac24e47.svg";